module.exports = __webpack_public_path__ + "img/ellipse-inside-blur.ce41dcd2.svg";